__turbopack_context__.v({
  "iconCard": "icon-picker-module__oLfssa__iconCard",
});
